module.exports = __webpack_public_path__ + "assets/icomoon.2aea267a.eot";